import { Flex, Box, Text } from "rebass/styled-components";
import Trans from "next-translate/Trans";
import Icon from "../common/Icon";
import { scroller } from "react-scroll";
import { useIsDesktop } from "../../lib/media";
import { useState } from "react";
import gql from "graphql-tag";
import { useMutation } from "@apollo/client";
import {
  GetCaregiverQuery,
  GetCurrentUserIdQuery
} from "../../generated/graphql";

const scrollTo = (id, offset) => {
  scroller.scrollTo(id, {
    duration: 800,
    delay: 0,
    offset: offset,
    smooth: "easeInOutQuart"
  });
};

const ADD_BOOKMARK = gql`
  mutation addBookmark($caregiverId: ID!) {
    addBookmark(input: { caregiverId: $caregiverId }) {
      caregiver {
        id
        bookmarked
      }
      errors {
        message
        path
      }
    }
  }
`;

const DELETE_BOOKMARK = gql`
  mutation deleteBookmark($caregiverId: ID!) {
    deleteBookmark(input: { caregiverId: $caregiverId }) {
      caregiver {
        id
        bookmarked
      }
      errors {
        message
        path
      }
    }
  }
`;

interface Props {
  list: {
    [item: string]: {
      name: string;
      path: string;
      render: boolean;
    };
  };
  caregiver: GetCaregiverQuery["caregiver"];
  currentUser: GetCurrentUserIdQuery["currentUser"];
}

const Sections = ({ list, currentUser, caregiver }: Props) => {
  const isDesktop = useIsDesktop();
  const [state, setState] = useState(caregiver?.bookmarked == "true");

  const [addBookmark] = useMutation(ADD_BOOKMARK);
  const [deleteBookmark] = useMutation(DELETE_BOOKMARK);

  const onClickAddBookmark = () => {
    addBookmark({
      variables: {
        caregiverId: caregiver?.id
      }
    });
    setState(true);
  };

  const onClickDeleteBookmark = () => {
    deleteBookmark({
      variables: {
        caregiverId: caregiver?.id
      }
    });
    setState(false);
  };

  let offset = -75;
  if (isDesktop) {
    offset -= 65;
  }

  return (
    <Flex
      variant="layout.sitterProfile"
      sx={{
        backgroundColor: "samoyedWhite",
        position: "sticky",
        top: [0, "65px"],
        zIndex: 2,
        borderBottom: "default"
      }}
    >
      <Box
        width={1}
        sx={{
          marginLeft: "auto",
          marginRight: "auto",
          overflowX: ["scroll", "hidden"]
        }}
      >
        <Flex
          justifyContent="flex-start"
          alignItems="baseline"
          sx={{
            position: "relative",
            ":after": {
              display: ["block", "none"],
              content: `""`,
              position: "absolute",
              top: 0,
              bottom: 0,
              right: currentUser ? "30px" : 0,
              pointerEvents: "none",
              backgroundImage: `linear-gradient(to right, rgba(255,255,255, 0), rgba(255,255,255, 0.9) 90%)`,
              width: "48px"
            }
          }}
        >
          <Box flex={1}>
            <Flex
              flexWrap="no-wrap"
              py={3}
              sx={{
                overflowX: "auto",
                ">*": {
                  flex: "0 0 auto",
                  color: "springGreen",
                  fontWeight: "book",
                  fontSize: 3,
                  cursor: "pointer"
                }
              }}
            >
              {Object.values(list).map((item, key) =>
                item.render ? (
                  <Box
                    key={key}
                    sx={{
                      marginRight: 3,
                      ":last-of-type": { paddingRight: [2, 0] }
                    }}
                  >
                    <a onClick={() => scrollTo(item.path, offset)}>
                      <Text>
                        <Trans i18nKey={item.name} />
                      </Text>
                    </a>
                  </Box>
                ) : null
              )}
            </Flex>
          </Box>
          <Box
            sx={{
              textAlign: "right",
              "> *": {
                marginLeft: [2, 3],
                cursor: "pointer"
              }
            }}
          >
            {currentUser ? (
              state == true ? (
                <Icon
                  name="favourite"
                  color={"inuOrange"}
                  onClick={onClickDeleteBookmark}
                ></Icon>
              ) : (
                <Icon
                  name="heart-shape"
                  color={"labradorBlack"}
                  onClick={onClickAddBookmark}
                ></Icon>
              )
            ) : null}
          </Box>
        </Flex>
      </Box>
    </Flex>
  );
};

export default Sections;
